import { render, staticRenderFns } from "./hs-slider-menu.vue?vue&type=template&id=0ba904e0"
import script from "./hs-slider-menu.vue?vue&type=script&lang=js"
export * from "./hs-slider-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports